define('container/extensions/SubscriptionManagerExtension',['underscore'], function(_) {

    'use strict';

    function SubscriptionManagerExtension() {

        var self = this,
            managedSubscriptions = [];

        self.canResolveArg = function(argDefinition) {
            return argDefinition === 'subscriptionManager';
        };

        self.resolveArg = function(argDefinition, extensionApi) {
            return Promise.resolve(self);
        };

        /**
         * @param {Function | Object} handler
         * @param {String | Null} methodName
         * @param {Object} callbacks
         */
        self.add = function(handler, methodName, callbacks) {

            managedSubscriptions = managedSubscriptions.concat(
                _.extend(
                    {
                        handler: handler,
                        methodName: methodName
                    },
                    callbacks
                )
            );

        };

        /**
         * Use this to start all subscriptions for a handler object, or a specific subscription of a handler function
         *
         * @param {Function | Object} handlerOrMethod
         * @param {String} [methodName]
         */
        self.start = manageSubscriptions(function(managedSubscription) {

            var handler = managedSubscription.handler,
                methodName = managedSubscription.methodName;

            managedSubscription.start(function(payload) {

                if (methodName) {
                    handler[methodName](payload);
                } else {
                    handler(payload);
                }

            });

        });

        /**
         * Use this to stop all subscriptions for a handler object, or a specific subscription of a handler function
         *
         * @param {Function | Object} handlerOrMethod
         * @param {String} [methodName]
         */
        self.stop = manageSubscriptions(function(managedSubscription) {
            managedSubscription.stop();
        });

        /**
         * Use this to dispose all subscriptions for a handler object, or a specific subscription of a handler function
         *
         * Further attempts to start them again will do nothing
         *
         * @param {Function | Object} handlerOrMethod
         * @param {String} [methodName]
         */
        self.dispose = manageSubscriptions(function(managedSubscription) {
            managedSubscription.stop();
            managedSubscriptions = _.without(managedSubscriptions, managedSubscription);
        });

        function manageSubscriptions(iteratee) {

            return function(handlerOrMethod, methodName) {

                var handler = handlerOrMethod,
                    method = handlerOrMethod;

                managedSubscriptions.forEach(function(managedSubscription) {

                    if (
                        managedSubscription.handler === handler && !methodName ||
                        managedSubscription.handler === handler && managedSubscription.methodName === methodName ||
                        managedSubscription.handler[managedSubscription.methodName] === method
                    ) {
                        iteratee(managedSubscription);
                    }

                });

            };

        }

    }

    return SubscriptionManagerExtension;

});

